<template lang="pug">
  .error
    i.icon.icon-close.error__icon(v-if="isIconShown")
    div(v-html="getErrorText")

</template>

<script>
export default {
  name: "Error",
  props: {
    code: { type: [String, Number], default: "" },
    text: { type: String, default: "" },
    isIconShown: { type: Boolean, default: true },
    extraParams: { type: Object, default: null },
  },
  data() {
    return {
      message_with_code: this.$t(`errors.with_code.text`),
      default_message: this.$t(`errors.default.text`),
    };
  },

  computed: {
    errorTexts() {
      return this.$t(`errors`);
    },
    getErrorText() {
      if (this.text) {
        return this.text;
      }
      let error_text;
      if (this.errorTexts[this.code]) {
        error_text = this.getCodeMessage(this.code);
      } else {
        error_text = this.code ? `${this.message_with_code} ${this.code}` : this.default_message;
      }

      return error_text;
    },
  },

  methods: {
    getCodeMessage(code) {
      return this.$t(`errors.${code}.text`, this.extraParams);
    },
  },
};
</script>
